/**
 * El ícono de «Actualizar»: dos flechas en círculo, el signo de recargar en
 * cualquier interfaz. Dibujado a mano, como `EngranajeIcono` y `OjoIcono`.
 */
export function ActualizarIcono() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
      <path
        d="M4.2 12a7.8 7.8 0 0 1 13.2-5.6l2.1 2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M19.5 4v4.4h-4.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8 12a7.8 7.8 0 0 1-13.2 5.6l-2.1-2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M4.5 20v-4.4h4.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
